import   React                 ,  
       { useState              ,
         useEffect             }  from 'react';

// import { useNavigate           }  from 'react-router-dom';
// import { Dispatch              }  from 'redux';
// import { useDispatch           }  from 'react-redux';

import   classNames               from 'classnames';

import   styles                   from './UserSheet.module.scss';

import   Field                    from '../../widget/inputs/Field';
import   Select                   from '../../widget/inputs/Select';
import   WidgetFrame              from '../../widget/navigation/WidgetFrame';
import   Window                   from '../../widget/windows/window';
import   Trigger                  from '../../widget/actuators/Trigger';
import   Toggle                   from '../../widget/inputs/Toggle';

import { User                  ,
         initializedUser       }  from '../../../dataTypes/userManagment/types';

import { convertStringToDate   ,
         convertDateToString }  from '../../../dataTypes/timeManagment/utils';

import { Validation            ,
         checkFirstname        ,
         checkLastname         ,
         checkSex              ,
         checkBirthday         ,
         checkAddress          ,
         checkAddress2         ,
         checkZipCode          ,
         checkCity             ,
         checkCountry          ,
         checkPhoneNumber      } from '../../../dataTypes/userManagment/validators';

import { patchUser}  from '../../../backendServices/userManagment/api';



type UserSheetProps = {
  user?: User;
  onCreationCancel?: () => void
}

export const UserSheet = ({ user , onCreationCancel}: UserSheetProps) => {

  const initialUser = user ? user : initializedUser()

console.log (initialUser)

  const now      = new Date();
  const nextYear = new Date(now.getFullYear()+1, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());


  const [ email                 , setEmail              ] = useState ( initialUser.email                                    );
  const [ status                , setStatus             ] = useState ( initialUser.status                                   );
  const [ statusDeadline        , setStatusDeadline     ] = useState ( initialUser.statusDeadline ??  nextYear              );
  const [ locked                , setLocked             ] = useState ( initialUser.locked                                   );

  const [ firstname             , setFirstname          ] = useState ( initialUser.firstname                                );
  const [ lastname              , setLastname           ] = useState ( initialUser.lastname                                 );
  const [ sex                   , setSex                ] = useState ( initialUser.sex === "" ? "Aucune réponse" : initialUser.sex );
  const [ birthday              , setBirthday           ] = useState ( initialUser.birthday                                 );
  const [ address               , setAddress            ] = useState ( initialUser.address                                  );
  const [ address2              , setAddress2           ] = useState ( initialUser.address2                                 );
  const [ zipCode               , setZipCode            ] = useState ( initialUser.zipCode                                  );
  const [ city                  , setCity               ] = useState ( initialUser.city                                     );
  const [ country               , setCountry            ] = useState ( initialUser.country === "" ? "France" : initialUser.country );
  const [ phoneNumber           , setPhoneNumber        ] = useState ( initialUser.phoneNumber                              );


  const [ messageEmail       ] = useState ('');
  const [ messageStatus      ] = useState ('');

  const [ messageFirstname      , setMessageFirstname   ] = useState ('');
  const [ messageLastname       , setMessageLastname    ] = useState ('');
  const [ messageSex            , setMessageSex         ] = useState ('');
  const [ messageBirthday       , setMessageBirthday    ] = useState ('');
  const [ messageAddress        , setMessageAddress     ] = useState ('');
  const [ messageAddress2       , setMessageAddress2    ] = useState ('');
  const [ messageZipCode        , setMessageZipCode     ] = useState ('');
  const [ messageCity           , setMessageCity        ] = useState ('');
  const [ messageCountry        , setMessageCountry     ] = useState ('');
  const [ messagePhoneNumber    , setMessagePhoneNumber ] = useState ('');
    
  const [ editMode              , setEditMode           ] = useState ( user ? false : true );
  
  const [ showWindow            , setShowWindow         ] = useState ( false );
  const [ windowMessage         , setWindowMessage      ] = useState ( <></> );


  const [          , setIsSmallScreen      ] = useState<boolean>(false);

  const switchWidthLimit = 870;

  const handleResize = () => {
    setIsSmallScreen ( window.innerWidth <= switchWidthLimit );
  };


  useEffect(() => {

    console.log (user)

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []); 

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setEmail    ( e.target.value )

    const retour: Validation = checkFirstname  ( e.target.value )
    setMessageFirstname ( retour.comment );
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

	console.log ('handleStatusChange', e.target.value)

    setStatus ( e.target.value === 'Découverte' ? 'Discover' : e.target.value )

    const retour: Validation = checkFirstname  ( e.target.value )
    setMessageFirstname ( retour.comment );
  };

  const handleFirstnameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setFirstname    ( e.target.value ) 
    const retour: Validation = checkFirstname  ( e.target.value )
    setMessageFirstname ( retour.comment );
  };

  const handleLastnameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setLastname    ( e.target.value ) 

    const retour: Validation = checkLastname  ( e.target.value )
    setMessageLastname ( retour.comment );
  };

  const handleSexChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setSex    ( e.target.value ) 

    const retour: Validation = checkSex  ( e.target.value )
    setMessageSex ( retour.comment );
  };

  const handleBirthdayChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value

    setBirthday  ( convertStringToDate (newDate) )
 //   setFirstUseDateMessage ( testFirstUseDate ( newDate ) )

  //  setBirthday    ( newBirthday )
//     dispatch ( updateBirthday ( newBirthday ) )
//
//     const retour: Validation = checkBirthday  ( newBirthday )
//    setMessageBirthday ( retour.comment );
  };

  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setAddress    ( e.target.value ) 

    const retour: Validation = checkAddress  ( e.target.value )
    setMessageAddress ( retour.comment );
  };

  const handleAddress2Change = (e: React.ChangeEvent<HTMLInputElement>) => {

    setAddress2    ( e.target.value ) 

    const retour: Validation = checkAddress2  ( e.target.value )
    setMessageAddress2 ( retour.comment );
  };
    
  const handleZipCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setZipCode    ( e.target.value ) 

    const retour: Validation = checkZipCode  ( e.target.value )
    setMessageZipCode ( retour.comment );
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setCity    ( e.target.value ) 

    const retour: Validation = checkCity  ( e.target.value )
    setMessageCity ( retour.comment );
  };

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setCountry    ( e.target.value )

    const retour: Validation = checkCountry  ( e.target.value )
    setMessageCountry ( retour.comment );
  };

  const handlePhoneNumberChange = async (e: React.ChangeEvent<HTMLInputElement>) => {

    setPhoneNumber    ( e.target.value ) 

    const retour: Validation = await checkPhoneNumber  ( e.target.value , initialUser.email )
    setMessagePhoneNumber ( retour.comment );
  };



/*
  const handleStatusDeadlineChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate: string = event.target.value;
    setStatusDeadline(convertStringToDate(newDate));
  };
  */
  
  const handleStatusDeadlineChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate);

    if (convertedDate)
          {
           setStatusDeadline(convertedDate);
          }
     else {
           setStatusDeadline(nextYear); // Assuming `nextYear` is defined as in your code
          }
  };


const handleLockedChange = (value: boolean) => {
 // makeUserLockStatusUpdate(value);

    setLocked(value);


    //  const fieldIsAlreadyModified = locked !== initialPaid;

    // if ( value === initialPaid &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    // if ( value !== initialPaid && !fieldIsAlreadyModified ) { setNumberOfModifiedFields(prev => prev + 1); }

};

/* Pas de locked immédiat 

const makeUserLockStatusUpdate = async (value: boolean) => {
  if (id !== 0) {
    const result = await updateUserLockStatus(id, value);

    if (result.code === 1) {
      setLocked(value);
    } else {
      console.error("Échec : impossible de mettre à jour le verrouillage utilisateur");
      // éventuellement : afficher un toast / message d'erreur
    }
  } else {
    // Nouveau user pas encore en base
    setLocked(value);
  }
};
*/

  const handleEditButtonClick = () => {

    setEditMode (!editMode);
  }

  const handleCancelButtonClick = () => {

    setEditMode (!editMode);
    if (onCreationCancel) onCreationCancel ();
  }

  const handleValidateButtonClick = () => {

    makeUpdate ();
  }

  const checkAll = async (): Promise<boolean> => {

    const retour04 =       checkFirstname   ( firstname )
    const retour05 =       checkLastname    ( lastname )
    const retour06 =       checkSex         ( sex )
    const retour07 =       checkBirthday    ( birthday )
    const retour08 =       checkAddress     ( address )
    const retour09 =       checkAddress2    ( address2 )
    const retour10 =       checkZipCode     ( zipCode )
    const retour11 =       checkCity        ( city )
    const retour12 =       checkCountry     ( country )
    const retour13 = await checkPhoneNumber ( phoneNumber , initialUser.email )

    setMessageFirstname   ( retour04.comment );
    setMessageLastname    ( retour05.comment );
    setMessageSex         ( retour06.comment );
    setMessageBirthday    ( retour07.comment );
    setMessageAddress     ( retour08.comment );
    setMessageAddress2    ( retour09.comment );
    setMessageZipCode     ( retour10.comment );
    setMessageCity        ( retour11.comment );
    setMessageCountry     ( retour12.comment );
    setMessagePhoneNumber ( retour13.comment );

    const code:number = retour04.code +
                        retour05.code +
                        retour06.code +
                        retour07.code +
                        retour08.code +
                        retour09.code +
                        retour10.code +
                        retour11.code +
                        retour12.code +
                        retour13.code;

    return ( code === 10 );

   }

  const handleCloseButtonClick = () => {

    setEditMode   (false);
    setWindowMessage ( <></>);
    setShowWindow ( false );
  }

  const makeUpdate = async () => {

    const check = await checkAll ()

    if ( check )
     {
 
      const response = await patchUser ( 
                                           // authentication.token      ,
                                         initialUser.id           ,
										 "",
                                         firstname    ,
                                         lastname     ,
                                         sex          ,
                                         birthday     ,
                                         address      ,
                                         address2     ,
                                         zipCode      ,
                                         city         ,
                                         country      ,
                                         phoneNumber  ,
                                         status       ,
                                         statusDeadline,
										 locked
                                       )


      switch ( response.code )
       {
        case 1    : setWindowMessage ( <>Les informations ont été mises à jour</> );
                    setShowWindow ( true );

                    break;

        // case -102 : setWindowMessage ( <>Votre session a expiré, veuillez vous reconnecter.</> );
                    // setShowWindow ( true );

                    // setExpiredSession (true);

                    // break;

        default   : setWindowMessage ( <>Le compte n'a pas pu être modifié car une erreur réseau est survenue</> );
                    setShowWindow ( true );

       }
     }
   }


  return (
            
           <div className={classNames(styles.root)}>

               {
                showWindow  &&
                (
                  < Window message                 = {windowMessage}
                           onClickOnValidateButton = {handleCloseButtonClick} />
                )
               }

               <p className={classNames(styles.title)}>
                 INFORMATIONS PERSONNELLES
               </p>

               <br/>

               <div className={classNames(styles.form)}>

               {/*
                 <div className={classNames(styles.userId)}>

                   <WidgetFrame name          = "Id :"
                                error         = {messageFirstname}
                                classNameGrid = {classNames(styles.grid_info)} >

                   {user.id}

                  </WidgetFrame>

                 </div>
               */}

                 <div className={classNames(styles.creationDate)}>

                   <WidgetFrame name               = "Date création : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageFirstname}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {true}
                                value         = {convertDateToString (initialUser.creationDate, 'dd/MM/yyyy HH:mm:ss')}/>                    

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.creationIpAddress)}>

                   <WidgetFrame name               = "IP création : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = ""
                                classNameGrid      = {classNames(styles.grid_info)} >
								
                        <Field  type          = "text"
						        readOnly      = {true}
                                value         = {`${initialUser.creationIpAddress} (${initialUser.ipApiCom_city} )`}/>                    

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.lastLoginDate)}>

                   <WidgetFrame name               = "Dernière connexion : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"        
                                error              = {messageFirstname}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {true}
                                value         = {convertDateToString (initialUser.lastLoginDate, 'dd/MM/yyyy HH:mm:ss')}/>                    
                     

                  </WidgetFrame>
                 </div>

                 <div className={classNames(styles.lastLoginIpAddress)}>

                   <WidgetFrame name               = "IP dernière connexion : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"        
                                error              = ""
                                classNameGrid      = {classNames(styles.grid_info)} >
								
                        <Field  type          = "text"
						        readOnly      = {true}
                                value         = {`${initialUser.lastLoginIpAddress} (${initialUser.lastLoginCity} )`}/>                    

                  </WidgetFrame>
                 </div>

                 <div className={classNames(styles.firstname)}>

                   <WidgetFrame name               = "Prénom : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"       
                                error              = {messageFirstname}
                                classNameGrid      = {classNames(styles.grid_info)} >
                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {firstname}
                                onChange      = {handleFirstnameChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.lastname)}>

                   <WidgetFrame name               = "Nom : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageLastname}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {lastname}
                                onChange      = {handleLastnameChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.email)}>

                   <WidgetFrame name               = "Email : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageEmail}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {email}
                                onChange      = {handleEmailChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.status)}>

                   <WidgetFrame name               = "Statut : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageStatus}
                                classNameGrid      = {classNames(styles.grid_info)} >


                        <div className={classNames(styles.statusWithDeadline)}>
                          <Select choices       = { [
                                                      "Discover",
                                                      "Standard",
                                                      "Premium"
                                                    ] }
                                  choicesLabel  = { [
                                                      "Découverte",
                                                      "Standard",
                                                      "Premium"
                                                    ] }		
						          disabled      = {!editMode}
                                  value         = {status}
                                  onChange      = {handleStatusChange}    />
                          &nbsp;&nbsp;
                          {
                           ( status === 'Standard' || status === 'Premium' )
                            &&
                           <Field value      = { statusDeadline ? convertDateToString ( statusDeadline , 'dd/MM/yyyy' ) : '' }
                                  onChange   = { handleStatusDeadlineChange }
						          readOnly   = {!editMode}
                                  type       = "calendar"
                                  dateFormat = "dd/MM/yyyy" />
                          }
                        </div>


                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.sex)}>

                   <WidgetFrame name               = "Sexe : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageSex}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Select choices       = { [
                                                    "Aucune réponse",
                                                    "Homme",
                                                    "Femme"
                                                  ] }
						        disabled      = {!editMode}
                                value         = {sex}
                                onChange      = {handleSexChange}    />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.birthday)}>

                   <WidgetFrame name               = "Date de naissance : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageBirthday}
                                classNameGrid      = {classNames(styles.grid_info)} >

                       <Field value      = {birthday ? convertDateToString (birthday, 'dd/MM/yyyy') : ''}
					          readOnly      = {!editMode}
                              onChange   = {handleBirthdayChange}
                              type       = "calendar"
                              dateFormat = 'dd/MM/yyyy'  />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.address)}>

                   <WidgetFrame name               = "Adresse : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" 
                                error              = {messageAddress}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {address}
                                onChange      = {handleAddressChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.address2)}>

                   <WidgetFrame name               = "Complément adresse : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"             
                                error              = {messageAddress2}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {address2}
                                onChange      = {handleAddress2Change} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.locked)}>

                   <WidgetFrame name               = "Vérrouillé : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"             
                                classNameGrid      = {classNames(styles.grid_info)} >

                      <Toggle checked     = {locked}
                              onChange    = {handleLockedChange}
                              form        = {editMode ? "switch":"bullet"} 
							  invertColor = {true} />
					
                  </WidgetFrame>

                 </div>
				 
                 <div className={classNames(styles.zipCode)}>

                   <WidgetFrame name               = "Code postal : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageZipCode}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {zipCode}
                                onChange      = {handleZipCodeChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.city)}>

                   <WidgetFrame name               = "Ville : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageCity}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {city}
                                onChange      = {handleCityChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.country)}>

                   <WidgetFrame name               = "Pays : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messageCountry}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Select choices       = { [
                                                    "France",
                                                    "Belgique",
                                                    "Suisse"
                                                  ] }
						        disabled      = {!editMode}
                                value         = {country}
                                onChange      = {handleCountryChange}    />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.phoneNumber)}>

                   <WidgetFrame name               = "Numéro de téléphone : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
                                error              = {messagePhoneNumber}
                                classNameGrid      = {classNames(styles.grid_info)} >

                        <Field  type          = "text"
						        readOnly      = {!editMode}
                                placeholder   = ""
                                value         = {phoneNumber}
                                onChange      = {handlePhoneNumberChange} />

                  </WidgetFrame>

                 </div>

                 <div className={classNames(styles.buttons)}>
                  <div className={classNames(styles.buttons_block)}>

                  {
                    (
                      editMode
                    )
                    ?
                    (
                      <>

                        <Trigger name="Annuler" onClick={handleCancelButtonClick} variant="tailwind2" />

                        &nbsp;&nbsp;&nbsp;

                        <Trigger name="Enregistrer" onClick={handleValidateButtonClick} variant="tailwind2" />

                      </>
                    )
                    :
                    (
                        <Trigger name="Modifier" onClick={handleEditButtonClick} variant="tailwind2" />
                    )
                  }

                  </div>
                 </div>

               </div>

           </div>
           
         );
};


export default UserSheet;
